/* ============================================================
   La Nani — stele intregi in insignele de recenzii
   Vezi theme/CLAUDE.md, sectiunea despre --star.

   Judge.me deseneaza jumatati de stea pentru note ca 4,67 sau 4,50.
   Le rotunjim la stele intregi, pentru ca sferturile de stea arata
   prost la 12px.

   Rotunjirea ascunde insa diferenta dintre 4,5 si 5,0. De aceea
   scriem nota exacta langa stele: „4,7 · 3 recenzii". Steaua devine
   un reper vizual, cifra ramane adevarul.

   Atentie: NU atingem stelele din widgetul de recenzii. Acolo fiecare
   recenzie are o nota intreaga data de un om, nu o medie.
   ============================================================ */
(function () {
  'use strict';

  var GATA = 'lnStele';

  function rotunjeste(insigna) {
    if (insigna.dataset[GATA]) return;

    var stele = insigna.querySelectorAll('.jdgm-star');
    if (!stele.length) return;

    /* nota vine de pe insigna sau de pe grupul de stele */
    var brut = insigna.getAttribute('data-average-rating');
    if (brut == null) {
      var grup = insigna.querySelector('[data-score]');
      if (grup) brut = grup.getAttribute('data-score');
    }
    var nota = parseFloat(brut);
    if (!isFinite(nota)) return;

    /* la cea mai apropiata stea intreaga */
    var pline = Math.round(nota);
    if (pline > stele.length) pline = stele.length;

    for (var i = 0; i < stele.length; i++) {
      stele[i].classList.remove('jdgm--half', 'jdgm--off', 'jdgm--on');
      stele[i].classList.add(i < pline ? 'jdgm--on' : 'jdgm--off');
    }

    scrieNota(insigna, nota);
    insigna.dataset[GATA] = '1';
  }

  /* Nota se rescrie de cate ori e nevoie, nu o singura data: Judge.me
     isi redeseneaza insigna dupa noi si ne suprascrie textul. Verificarea
     e ieftina si nu se acumuleaza, pentru ca punem prefixul doar daca
     lipseste. */
  function scrieNota(insigna, nota) {
    var text = insigna.querySelector('.jdgm-prev-badge__text');
    if (!text) return;
    var cifra = nota.toFixed(1).replace('.', ',');
    var acum = text.textContent.trim();
    if (acum.indexOf(cifra + ' ·') === 0) return;
    /* scoatem o nota veche, daca s-a schimbat media intre timp */
    acum = acum.replace(/^\d+,\d+ · /, '');
    text.textContent = cifra + ' · ' + acum;
  }


  /* ============================================================
     Recenziile din cosul de cumparaturi, cele mai bune primele.

     Judge.me le da in ordine cronologica. Nota fiecarei recenzii se
     citeste din aria-label ("5 out of 5 stars"), pentru ca acolo o
     pune widgetul si nu exista alt atribut cu valoarea.

     Verificam intai daca lista e deja ordonata si iesim, altfel
     observatorul de DOM ar reordona la nesfarsit: fiecare mutare de
     element e o mutatie care ne-ar chema din nou.
     ============================================================ */
  function notaRecenziei(el) {
    var sr = el.querySelector('.jm-star-rating');
    var et = sr && sr.getAttribute('aria-label');
    var m = et && et.match(/([0-9]+(?:[.,][0-9]+)?)/);
    return m ? parseFloat(m[1].replace(',', '.')) : -1;
  }

  /* Sortam toate listele de recenzii: si cea din cosul de cumparaturi,
     si cea de pe pagina de produs. Cele mai bune sus.

     Daca vizitatorul foloseste el sortarea widgetului, ne oprim: alegerea
     lui are prioritate, altfel i-am rescrie ordinea sub mana. */
  var sortareaOprita = false;

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[class*="sort-filter"], [class*="jm-sort"], [class*="sorting"]')) {
      sortareaOprita = true;
    }
  }, true);

  function sorteazaLista(lista) {
    var items = [];
    for (var i = 0; i < lista.children.length; i++) {
      if (lista.children[i].classList.contains('jm-review-item')) items.push(lista.children[i]);
    }
    if (items.length < 2) return;

    /* deja ordonata descrescator? nu atingem DOM-ul, altfel observatorul
       ne-ar chema la nesfarsit */
    for (var j = 1; j < items.length; j++) {
      if (notaRecenziei(items[j]) > notaRecenziei(items[j - 1])) {
        items.sort(function (a, b) { return notaRecenziei(b) - notaRecenziei(a); });
        for (var k = 0; k < items.length; k++) lista.appendChild(items[k]);
        return;
      }
    }
  }

  function sorteazaListe() {
    if (sortareaOprita) return;
    var liste = document.querySelectorAll('.jdgm-review-list');
    for (var i = 0; i < liste.length; i++) sorteazaLista(liste[i]);
  }
  function treci() {
    var lista = document.querySelectorAll('.ln-badge .jdgm-prev-badge');
    for (var i = 0; i < lista.length; i++) {
      var b = lista[i];
      if (b.dataset[GATA]) {
        /* stelele sunt gata, dar nota poate fi fost stearsa de Judge.me */
        var n = parseFloat(b.getAttribute('data-average-rating'));
        if (isFinite(n)) scrieNota(b, n);
      } else {
        rotunjeste(b);
      }
    }
    sorteazaListe();
  }

  /* Insignele sunt desenate de scriptul Judge.me dupa incarcarea paginii,
     iar widgetul din cos abia cand deschizi cosul. Deci urmarim DOM-ul.

     Strangulam cu setTimeout, nu cu requestAnimationFrame: rAF e oprit in
     taburile ascunse sau care nu deseneaza, iar atunci cosul s-ar deschide
     cu recenziile nesortate si cu stelele nerotunjite. setTimeout ruleaza
     oricum, chiar daca mai incet. */
  var inCoada = 0;
  function programeaza() {
    if (inCoada) return;
    inCoada = setTimeout(function () { inCoada = 0; treci(); }, 0);
  }

  if ('MutationObserver' in window) {
    new MutationObserver(programeaza).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  ['shopify:section:load', 'shopify:block:select'].forEach(function (ev) {
    document.addEventListener(ev, programeaza);
  });

  /* Dupa o adaugare in cos, Judge.me isi redeseneaza widgetul de cateva
     ori pana se aseaza. Cateva treceri intarziate prind si ultima varianta.
     Sunt ieftine: fiecare iese imediat daca nu e nimic de schimbat. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-ln-cta], [data-ln-rel-add], [data-ln-sticky] button')) return;
    [400, 1200, 2500].forEach(function (ms) { setTimeout(treci, ms); });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', treci);
  } else {
    treci();
  }
  window.addEventListener('load', treci);
})();
